/* eslint-disable */
/**
 * Mock implementation of the Datatrans SecureFields 2.0.0 library for test environments.
 *
 * Mirrors the public API of secure-fields-2.0.0.sandbox.js but does NOT make
 * any real HTTP calls to Datatrans. All card routing is handled locally:
 *
 *   - 5404000000000001 → 3DS challenge (redirects to /mock_3ds)
 *   - 4111111111111111 → 3DS challenge (redirects to /mock_3ds)
 *   - 5019555544445555 → validation error (unsupported card)
 *   - CVV "0" or empty  → validation error (invalid CVV)
 *   - Any other card    → frictionless success (no redirect)
 */

var THREE_DS_CARDS = ['5404000000000001', '4111111111111111'];
var UNSUPPORTED_CARD = '5019555544445555';

function createIframe(placeholderElementId, placeholderText, fieldName, onInput) {
  var placeholder = document.getElementById(placeholderElementId);
  if (!placeholder) return null;

  var iframe = document.createElement('iframe');
  iframe.style.width = '100%';
  iframe.style.height = '42px';
  iframe.style.border = 'none';
  var ph = placeholderText ? ' placeholder="' + placeholderText + '"' : '';
  iframe.srcdoc = [
    '<!DOCTYPE html><html><head>',
    '<style>body{margin:0;padding:0;}',
    'input{width:100%;height:42px;box-sizing:border-box;padding:6px;',
    'font-size:16px;border:1px solid #ccc;border-radius:4px;outline:none;}</style>',
    '</head><body><input type="text" id="field" autocomplete="off"' + ph + '/>',
    '</body></html>',
  ].join('');

  iframe.addEventListener('load', function() {
    var input = iframe.contentDocument && iframe.contentDocument.querySelector('input#field');
    if (!input) return;

    input.addEventListener('input', function() {
      onInput(fieldName, input.value);
    });

    input.addEventListener('focus', function() {
      onInput(fieldName, input.value, 'focus');
    });

    input.addEventListener('blur', function() {
      onInput(fieldName, input.value, 'blur');
    });
  });

  placeholder.appendChild(iframe);
  return iframe;
}

function readIframeValue(iframe) {
  if (!iframe) return '';
  try {
    var input = iframe.contentDocument.querySelector('input#field');
    return input ? input.value : '';
  } catch (e) {
    return '';
  }
}

function getApiBaseUrl() {
  var el = document.querySelector('meta[name="ENV_API_BASE_URL"]');
  return el ? (el.getAttribute('content') || 'http://api.flightvoucher.test') : 'http://api.flightvoucher.test';
}

function findRedirectUrl() {
  // The Vue store persists the redemption in sessionStorage
  try {
    var redemption = JSON.parse(sessionStorage.getItem('redemption') || '{}');
    var redemptionId = redemption.id;
    if (redemptionId) {
      return getApiBaseUrl() + '/redemptions/' + redemptionId + '/3d_secure_redirect';
    }
  } catch (e) { /* fallback below */ }

  // Fallback: Stimulus controller data attribute (booking/shop flows)
  var el = document.querySelector('[data-redemption-payment-return-url-value]') ||
           document.querySelector('[data-datatrans-redirect-url-value]');
  if (el) {
    return el.getAttribute('data-redemption-payment-return-url-value') ||
           el.getAttribute('data-datatrans-redirect-url-value') || '/';
  }

  return '/';
}

function MockSecureFields() {
  var callbacks = {};
  var cardNumberIframe = null;
  var cvvIframe = null;
  var storedTransactionId = null;

  // Tracks the current values so we can build the change event payload
  var fieldValues = {
    cardNumber: '',
    cvv: '',
  };

  function emit(event, data) {
    if (callbacks[event]) {
      callbacks[event](data);
    }
  }

  function handleFieldInput(fieldName, value, eventType) {
    fieldValues[fieldName] = value;
    var type = eventType || 'input';

    // Build the fields payload that payment.ts expects on the 'change' event:
    // { event: { type, field }, fields: { cardNumber: { valid, length }, cvv: { valid, length } } }
    var cardLen = (fieldValues.cardNumber || '').replace(/\s/g, '').length;
    var cvvLen = (fieldValues.cvv || '').length;

    emit('change', {
      event: { type: type, field: fieldName },
      fields: {
        cardNumber: { valid: cardLen >= 13, length: cardLen },
        cvv: { valid: cvvLen >= 2, length: cvvLen },
      },
    });
  }

  this.init = function(_transactionId, fields, _options) {
    storedTransactionId = _transactionId;
    if (fields.cardNumber && fields.cardNumber.placeholderElementId) {
      cardNumberIframe = createIframe(
        fields.cardNumber.placeholderElementId,
        fields.cardNumber.placeholder,
        'cardNumber',
        handleFieldInput
      );
    }
    if (fields.cvv && fields.cvv.placeholderElementId) {
      cvvIframe = createIframe(
        fields.cvv.placeholderElementId,
        fields.cvv.placeholder,
        'cvv',
        handleFieldInput
      );
    }
    setTimeout(function() { emit('ready'); }, 0);
  };

  this.on = function(event, callback) {
    callbacks[event] = callback;
  };

  this.submit = function(_parameters) {
    var cardNumber = readIframeValue(cardNumberIframe).replace(/\s/g, '');
    var cvv = readIframeValue(cvvIframe);

    if (!cardNumber || cardNumber === UNSUPPORTED_CARD) {
      emit('validate', {
        hasErrors: true,
        fields: { cardNumber: { valid: false }, cvv: { valid: true } },
      });
      return;
    }

    if (!cvv || cvv.length < 2) {
      emit('validate', {
        hasErrors: true,
        fields: { cardNumber: { valid: true }, cvv: { valid: false } },
      });
      return;
    }

    if (THREE_DS_CARDS.indexOf(cardNumber) !== -1) {
      var returnUrl = findRedirectUrl();
      emit('success', {
        transactionId: storedTransactionId,
        redirect: getApiBaseUrl() + '/mock_3ds?returnUrl=' + encodeURIComponent(returnUrl),
      });
      return;
    }

    emit('success', { transactionId: storedTransactionId });
  };

  this.setStyle = function() {};
  this.setPlaceholder = function() {};
  this.setAriaLabel = function() {};
  this.focus = function() {};
  this.clear = function() {};
  this.validate = function() {};
  this.destroy = function() {};
}

module.exports = MockSecureFields;
